import { type Component, markRaw } from "vue";
import { useModal } from "@/components/Modal/state.ts";
import type { Options } from "@/components/Modal/types";

const confirm = (component: Component, callback: () => void, options?: Options): void => {
  const state = useModal();

  state.open(markRaw(component), callback, options);
};

export { confirm };
